export default __webpack_public_path__ + "static/certificate-aicpa-b651773a1efc2451324717614ceeb77c.svg";